import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "py-4 pe-4",
  style: {"line-height":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_app_version = _resolveComponent("app-version")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    color: "gray-darken-3",
    modelValue: _ctx.isActive,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isActive) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, { nav: true }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, ({ icon, text, to }, key) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              class: "py-0 mb-2",
              key: key,
              to: to
            }, {
              prepend: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_component_v_icon, { icon: icon }, null, 8, ["icon"])
                ])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" " + _toDisplayString(text), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_app_version, { class: "d-none" })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}